import {
    AdminUserAttributesDocument as adminQuery,
    AdminUserAttributesQuery,
    GetAuctionIdDocument as auctionIdQuery,
    GetAuctionIdQuery,
    QueryResolvers,
} from '../../../../../generated/graphql'

const adminUserAttributesResolver: QueryResolvers['adminUserAttributes'] = async (
    _root,
    { userId },
    { cache, client },
) => {
    if (!userId) {
        return {
            __typename: 'UserAttributes',
            firstName: null,
            lastName: null,
        }
    }

    const cacheData = cache.readQuery<GetAuctionIdQuery>({
        query: auctionIdQuery,
    })
    const auctionId = cacheData?.activeOrganization?.orgId

    const { data } =
        (await client?.query<AdminUserAttributesQuery>({
            query: adminQuery,
            variables: { userId, auctionId },
        })) || {}

    if (!data?.administrator?.user?.attributes) {
        return {}
    }

    return data.administrator.user.attributes
}

export default adminUserAttributesResolver
